import {
  searchVehicleFilterAddButton,
  searchVehicleFilterChangeClick,
  searchVehicleFilterChangeLicenseNumber,
  searchVehicleFilterCleanClick,
  searchVehicleFilterContentClick,
  searchVehicleFilterLicenseNumberClick,
  searchVehicleFilterResetClick,
  searchVehicleFilterView,
} from "@magalu/ecomm-components/features/search/events/searchVehicleFilter";
import { startExperiment } from "@magalu/ecomm-components/features/search/events/startExperiment";
import allInHandleWishlist from "@magalu/ecomm-components/rave/events/AllIn/handleWishlist";
import allInPageView from "@magalu/ecomm-components/rave/events/AllIn/pageView";
import { cloudRetailAddToCart } from "@magalu/ecomm-components/rave/events/CloudRetail/addToCart";
import { cloudRetailView } from "@magalu/ecomm-components/rave/events/CloudRetail/viewItem";
import addToCartSuccessCookie from "@magalu/ecomm-components/rave/events/Cookies/addToCart";
import gaAddToCartSuccessCookie from "@magalu/ecomm-components/rave/events/Cookies/gaAddToCart";
import criteoAddToCart from "@magalu/ecomm-components/rave/events/Criteo/addToCart";
import criteoPageView from "@magalu/ecomm-components/rave/events/Criteo/pageView";
import { addToCartError } from "@magalu/ecomm-components/rave/events/GA/add-to-cart";
import { brandListItemClick } from "@magalu/ecomm-components/rave/events/GA/all-brands";
import {
  triggerCardanAskSellerClickEvent,
  triggerCardanChangeVehicleClickEvent,
  triggerCardanViewContentEvent,
} from "@magalu/ecomm-components/rave/events/GA/cardan-pdp";
import { filterLinkListClick } from "@magalu/ecomm-components/rave/events/GA/filter";
import {
  luContentClick,
  luContentView,
} from "@magalu/ecomm-components/rave/events/GA/luContent";
import { luLoginCardClick } from "@magalu/ecomm-components/rave/events/GA/luLoginCard";
import { clickPagination } from "@magalu/ecomm-components/rave/events/GA/pagination";
import { productLabelClick } from "@magalu/ecomm-components/rave/events/GA/product-label";
import {
  productPaymentChange,
  productPaymentClick,
} from "@magalu/ecomm-components/rave/events/GA/product-payment";
import { productViewItem } from "@magalu/ecomm-components/rave/events/GA/product-view-item";
import {
  productBenefitCardClick,
  productBenefitsRefundLinkClick,
  productBenefitsView,
} from "@magalu/ecomm-components/rave/events/GA/productBenefit";
import {
  promoterOfferButtonClick,
  promoterOfferViewItemList,
} from "@magalu/ecomm-components/rave/events/GA/promoterOffer";
import {
  questionClickConfirmQuestion,
  questionClickOpenConfirm,
  questionFeedbackResponseError,
  questionFormSeeMore,
  questionListImpression,
} from "@magalu/ecomm-components/rave/events/GA/questions";
import {
  reviewPdpClick,
  reviewSeeMoreClick,
} from "@magalu/ecomm-components/rave/events/GA/review";
import {
  searchClear,
  searchClose,
  searchTopTermClick,
} from "@magalu/ecomm-components/rave/events/GA/search";
import {
  sellerInfoPdpLinkClick,
  sellerScoreCalcInfoClick,
  sellerScoreImpression,
} from "@magalu/ecomm-components/rave/events/GA/seller";
import { sellerChatOpen } from "@magalu/ecomm-components/rave/events/GA/sellerChat";
import { showcaseItemClick } from "@magalu/ecomm-components/rave/events/GA/showcase-item-click";
import {
  zipCodeClick,
  zipCodeClickConfirm,
  zipCodeClickDontKnowCep,
  zipCodeClickEditAddresses,
  zipCodeClickToggleAddresses,
  zipCodeResponseError,
  zipCodeResponseSuccess,
} from "@magalu/ecomm-components/rave/events/GA/zipCode";
import {
  ClickCloseDrawer,
  ClickShowBasket,
  ClickShowMoreProducts,
  ShowAddBasketSuccessDrawer,
} from "@magalu/ecomm-components/rave/events/GA4/addBasketSuccessDrawer";
import { addToCart } from "@magalu/ecomm-components/rave/events/GA4/addToCart";
import { addToWishList } from "@magalu/ecomm-components/rave/events/GA4/addToWishList";
import {
  allBrandsLetterFilterClick,
  brandClick,
} from "@magalu/ecomm-components/rave/events/GA4/allBrands";
import {
  buyBoxAddToCart,
  seeMoreOffers,
} from "@magalu/ecomm-components/rave/events/GA4/buyBox";
import { buyButtonServicesOnClick } from "@magalu/ecomm-components/rave/events/GA4/buyButtonServicesOnClick";
import { calculateTaxes } from "@magalu/ecomm-components/rave/events/GA4/calculateTaxes";
import {
  chatSellerEvent,
  chatSellerSelectContent,
} from "@magalu/ecomm-components/rave/events/GA4/chatSeller";
import {
  couponSelectContent,
  couponViewContent,
} from "@magalu/ecomm-components/rave/events/GA4/coupon";
import { footerItemClick } from "@magalu/ecomm-components/rave/events/GA4/footer";
import {
  clickAccountOption,
  clickBasketButton,
  clickDeliveryAt,
  clickDropdownMenu,
  clickFavoritePage,
  clickMenuButton,
  clickMenuItem,
  clickSignupOrLogin,
  clickZipcodeModalLoginButton,
} from "@magalu/ecomm-components/rave/events/GA4/header";
import { clickChipItem } from "@magalu/ecomm-components/rave/events/GA4/headerTrend";
import {
  hotlinkClick,
  viewPromotionHotlink,
} from "@magalu/ecomm-components/rave/events/GA4/hotlinks";
import { importTaxesInfoModalClose } from "@magalu/ecomm-components/rave/events/GA4/importTaxesInfoModalClose";
import {
  productDetailClick,
  productDetailView,
} from "@magalu/ecomm-components/rave/events/GA4/productDetailView";
import {
  productDisplayClick,
  productDisplayView,
} from "@magalu/ecomm-components/rave/events/GA4/productRating";
import {
  productSellerChat,
  productSellerClick,
} from "@magalu/ecomm-components/rave/events/GA4/productSeller";
import {
  selectPromotionBanner,
  selectPromotionBannerVideo,
  videoCompletePromotionBanner,
  videoProgressPromotionBanner,
  videoStartPromotionBanner,
  viewPromotionBanner,
  viewPromotionBannerVideo,
} from "@magalu/ecomm-components/rave/events/GA4/promotionBanner";
import {
  quantitySelector,
  maxQuantityModalClick,
  maxQuantityModalView,
} from "@magalu/ecomm-components/rave/events/GA4/quantitySelector";
import { removeFromCart } from "@magalu/ecomm-components/rave/events/GA4/removeFromCart";
import { removeFromWishlistSelectContent } from "@magalu/ecomm-components/rave/events/GA4/removeFromWishlist";
import {
  reviewSelectBackToHome,
  reviewSelectContent,
  reviewSendContent,
} from "@magalu/ecomm-components/rave/events/GA4/review";
import {
  clickSearchSuggestion,
  search,
  submitSearchInput,
} from "@magalu/ecomm-components/rave/events/GA4/search";
import {
  clickFilters,
  searchPageFastFiltersChipClick,
  searchPageFastFiltersChipView,
  searchPageFastFiltersView,
  searchPageQuickFiltersChipClick,
  searchPageShowAllFastFiltersView,
  searchPageShowResultsClick,
  searchViewResultsFiltered,
} from "@magalu/ecomm-components/rave/events/GA4/searchPage";
import { selectContent } from "@magalu/ecomm-components/rave/events/GA4/selectContent";
import { selectItem } from "@magalu/ecomm-components/rave/events/GA4/selectItem";
import {
  selectSellerBanner,
  viewSellerBanner,
} from "@magalu/ecomm-components/rave/events/GA4/sellerBanner";
import { sellerPageSelectContent } from "@magalu/ecomm-components/rave/events/GA4/sellerPageSelectContent";
import { shareClick } from "@magalu/ecomm-components/rave/events/GA4/share";
import { shippingGA4 } from "@magalu/ecomm-components/rave/events/GA4/shipping";
import { shippingResponseErrorGA4 } from "@magalu/ecomm-components/rave/events/GA4/shippingResponseErrorGA4";
import { shippingView } from "@magalu/ecomm-components/rave/events/GA4/shippingView";
import { showcaseLoadMoreSelectContent } from "@magalu/ecomm-components/rave/events/GA4/showcaseLoadMoreSelectContent";
import {
  selectSuperHotlinkPromotion,
  viewSuperHotlinkPromotion,
} from "@magalu/ecomm-components/rave/events/GA4/superHotlinkPromotion";
import {
  videoCartInteraction,
  videoInteraction,
} from "@magalu/ecomm-components/rave/events/GA4/videoInteraction";
import { viewItem } from "@magalu/ecomm-components/rave/events/GA4/viewItem";
import { viewItemList } from "@magalu/ecomm-components/rave/events/GA4/viewItemList";
import { virtualPageview } from "@magalu/ecomm-components/rave/events/GA4/virtualPageview";
import { zipCodeValidation } from "@magalu/ecomm-components/rave/events/GA4/zipCode";
import rtbhAddToCart from "@magalu/ecomm-components/rave/events/RTBHouse/add-to-cart";
import rtbhAddToWishList from "@magalu/ecomm-components/rave/events/RTBHouse/add-to-wish-list";
import rtbhPageView from "@magalu/ecomm-components/rave/events/RTBHouse/page-view";
import spotifyAddToCart from "@magalu/ecomm-components/rave/events/SpotifyAdAnalytics/add-to-cart";
import spotifyAddToWishList from "@magalu/ecomm-components/rave/events/SpotifyAdAnalytics/add-to-wish-list";
import spotifyPageView from "@magalu/ecomm-components/rave/events/SpotifyAdAnalytics/page-view";
import stewieAddToCart from "@magalu/ecomm-components/rave/events/Stewie/add-to-cart";
import stewiePageView from "@magalu/ecomm-components/rave/events/Stewie/page-view";
import stewieProductListClick from "@magalu/ecomm-components/rave/events/Stewie/product-list-click";
import tiktokAddToCart from "@magalu/ecomm-components/rave/events/TikTok/add-to-cart";
import tikTokViewItem from "@magalu/ecomm-components/rave/events/TikTok/view-item";

import { recs } from "./constants/recs";
import { gateKeeperButtonClick } from "./events/gate-keeper";
import { rtbhHomePageView } from "./events/rtbh-home-page-view";

const events = (): unknown => ({
  "addtocart:error": [addToCartError],
  "addtocart:success": [
    addToCart,
    addToCartSuccessCookie,
    gaAddToCartSuccessCookie,
    tiktokAddToCart,
    spotifyAddToCart,
    rtbhAddToCart,
    stewieAddToCart,
    cloudRetailAddToCart,
    criteoAddToCart,
  ],
  "addtocartdrawer:close": [ClickCloseDrawer],
  "addtocartdrawer:show": [ShowAddBasketSuccessDrawer],
  "addtocartdrawer:show-basket": [ClickShowBasket],
  "addtocartdrawer:show-more-products": [ClickShowMoreProducts],
  "allbrands:letter:filter:click": [allBrandsLetterFilterClick],
  "brand:click": [brandClick],
  "buybox:addtocart": [buyBoxAddToCart],
  "buybox:seemoreoffers": [seeMoreOffers],
  "buybox:selectItem": [selectItem],
  "buybox:viewitemlist": [viewItemList],
  "cardan:ask-seller-click": [triggerCardanAskSellerClickEvent],
  "cardan:change-vehicle-click": [triggerCardanChangeVehicleClickEvent],
  "cardan:view-content": [triggerCardanViewContentEvent],
  "click:brandListItem": [brandListItemClick],
  "click:buyButtonServices": [buyButtonServicesOnClick],
  "click:pagination": [clickPagination],
  "click:promoterOffer:button": [promoterOfferButtonClick, selectItem],
  "click:sellerChat": [sellerChatOpen],
  "click:zipCodeBar": [zipCodeClick],
  "coupon:selectItem": [couponSelectContent],
  "coupon:viewItem": [couponViewContent],
  "footer:click:item": [footerItemClick],
  "gatekeeper:click": [gateKeeperButtonClick],
  "header:click:account-option": [clickAccountOption],
  "header:click:account-option:chatSellers": [chatSellerEvent],
  "header:click:delivery-at": [clickDeliveryAt],
  "header:click:dropdown:item": [clickDropdownMenu],
  "header:click:menu:basket": [clickBasketButton],
  "header:click:menu:button": [clickMenuButton],
  "header:click:menu:favorite": [clickFavoritePage],
  "header:click:menu:item": [clickMenuItem],
  "header:click:signup-login": [clickSignupOrLogin],
  "header:click:zipcode-modal:login:button": [clickZipcodeModalLoginButton],
  "header:submit:search:input": [submitSearchInput],
  "header:virtual_page_view": [virtualPageview],
  "hotlink:click": [hotlinkClick],
  "hotlink:view_promotion": [viewPromotionHotlink],
  "listlink:click": [filterLinkListClick],
  "location:success:update": [zipCodeValidation],
  "lucontent:vertical:item:click": [luContentClick],
  "lucontent:vertical:item:view": [luContentView],
  "lulogincard:click": [luLoginCardClick],
  "officialstores:superhotlink:select:promotion": [selectSuperHotlinkPromotion],
  "officialstores:superhotlink:view:promotion": [viewSuperHotlinkPromotion],
  pageView: [
    viewItem,
    tikTokViewItem,
    allInPageView,
    criteoPageView,
    spotifyPageView,
    rtbhHomePageView,
    rtbhPageView,
    search,
    stewiePageView,
    virtualPageview,
    cloudRetailView,
  ],
  "product:benefits:refund:link:click": [productBenefitsRefundLinkClick],
  "product:benefits:tags:click": [productBenefitCardClick],
  "product:benefits:view": [productBenefitsView],
  "product:calculateTaxes": [calculateTaxes],
  "product:detail:click": [productDetailClick],
  "product:detail:view": [productDetailView],
  "product:display:click": [productDisplayClick],
  "product:display:review": [productDisplayView],
  "product:image:chatSeller:click": [chatSellerEvent],
  "product:importTaxesClose:click": [importTaxesInfoModalClose],
  "product:installments:click": [productPaymentClick],
  "product:item:click": [selectItem, showcaseItemClick, stewieProductListClick],
  "product:item:view": [viewItemList],
  "product:label:click": [productLabelClick],
  "product:max-quantity-modal:click": [maxQuantityModalClick],
  "product:max-quantity-modal:view": [maxQuantityModalView],
  "product:paymentmethod:change": [productPaymentChange],
  "product:quantity:changed": [quantitySelector],
  "product:rating:click": [reviewPdpClick],
  "product:seller:chat:click": [productSellerChat],
  "product:seller:click": [productSellerClick],
  "product:seller:details:chat:click": [chatSellerEvent],
  "product:share:click": [shareClick],
  "product:shipping": [shippingGA4],
  "product:shipping:details": [productViewItem],
  "product:shipping:error": [shippingResponseErrorGA4],
  "product:shipping:view": [shippingView],
  "product:showcase:see-more:click": [showcaseLoadMoreSelectContent],
  "product:view": [viewItemList],
  "product:wishlist:click": [
    allInHandleWishlist,
    spotifyAddToWishList,
    rtbhAddToWishList,
    addToWishList,
    removeFromWishlistSelectContent,
  ],
  "productlist:click": [selectItem, selectContent],
  "promoterOffer:item:view": [promoterOfferViewItemList],
  "promotion:click": [selectPromotionBanner],
  "promotion:video:click": [selectPromotionBannerVideo],
  "promotion:video:complete": [videoCompletePromotionBanner],
  "promotion:video:progress": [videoProgressPromotionBanner],
  "promotion:video:start": [videoStartPromotionBanner],
  "promotion:video:view": [viewPromotionBannerVideo],
  "promotion:view": [viewPromotionBanner],
  "question-confirm:click": [questionClickConfirmQuestion],
  "question-feedback:error": [questionFeedbackResponseError],
  "question-form:see-more": [questionFormSeeMore],
  "question-list:impression": [questionListImpression],
  "question:form:submit": [questionClickOpenConfirm],
  "removefromcart:success": [removeFromCart],
  "review:finishreview:success:backtohome": [reviewSelectBackToHome],
  "review:selectcontent:view-image": [reviewSelectContent],
  "review:selectcontent:view-video": [reviewSelectContent],
  "review:selectcontent:write-review": [reviewSelectContent],
  "review:sendcontent:send-image": [reviewSendContent],
  "review:sendcontent:send-tags": [reviewSendContent],
  "review:sendcontent:send-video": [reviewSendContent],
  "reviewpdp:button:click": [reviewSeeMoreClick],
  "search:chip:item:click": [clickChipItem],
  "search:clear": [searchClear],
  "search:close": [searchClose],
  "search:fastfilters:chip:click": [searchPageFastFiltersChipClick],
  "search:fastfilters:chip:view": [searchPageFastFiltersChipView],
  "search:fastfilters:view": [searchPageFastFiltersView],
  "search:quickfilters:chip:click": [searchPageQuickFiltersChipClick],
  "search:select:chip:click": [clickFilters],
  "search:showall:fastfilters:view": [searchPageShowAllFastFiltersView],
  "search:showresults:click": [searchPageShowResultsClick],
  "search:start:experiment": [startExperiment],
  "search:suggestion:click": [clickSearchSuggestion],
  "search:topterm:click": [searchTopTermClick],
  "search:viewresults:click": [searchViewResultsFiltered],
  "seller:banner:click": [selectSellerBanner],
  "seller:banner:view": [viewSellerBanner],
  "seller:info:impression": [sellerScoreImpression],
  "seller:info:pdp:open:modal:click": [sellerInfoPdpLinkClick],
  "seller:info:selectcontent:chatSeller:click": [chatSellerSelectContent],
  "seller:page:selectcontent:click": [sellerPageSelectContent],
  "seller:score:calc:info:click": [sellerScoreCalcInfoClick],
  "unavailableProductsRedirect:click": [selectContent],
  "vehicleFilter:changeForm:plateNumber:click": [
    searchVehicleFilterChangeLicenseNumber,
  ],
  "vehicleFilter:changeVehicle:click": [searchVehicleFilterChangeClick],
  "vehicleFilter:search:cleanContent:click": [searchVehicleFilterCleanClick],
  "vehicleFilter:search:content:click": [searchVehicleFilterContentClick],
  "vehicleFilter:search:plateNumber:click": [
    searchVehicleFilterLicenseNumberClick,
  ],
  "vehicleFilter:search:resetVehicle:click": [searchVehicleFilterResetClick],
  "vehicleFilter:search:selectCar:click": [searchVehicleFilterAddButton],
  "vehicleFilter:search:view": [searchVehicleFilterView],
  "video:cart:interaction": [videoCartInteraction],
  "video:interaction": [videoInteraction],
  "zipcodebar:click:confirm": [zipCodeClickConfirm],
  "zipcodebar:click:dont-know-cep": [zipCodeClickDontKnowCep],
  "zipcodebar:click:edit-addresses": [zipCodeClickEditAddresses],
  "zipcodebar:click:toggle-addresses": [zipCodeClickToggleAddresses],
  "zipcodebar:response:error": [zipCodeResponseError],
  "zipcodebar:response:success": [zipCodeResponseSuccess],
});

export default events;

export const config = {
  recs,
};
